import type { CourseDraftCreateLocalizedSectionsItem } from './courseDraftCreateLocalizedSectionsItem';

/**
 * 언어별 섹션 정보 매핑
 */
export type CourseDraftCreateLocalizedSections = {[key: string]: CourseDraftCreateLocalizedSectionsItem[]};
